export default function(routes, redirectRoute) {
	return function(to, from, next) {
		if (!routes.includes(window.opener?.location.pathname)) {
			return next(redirectRoute);
		}
		return next();
	};
}
